import React from "react";

import type {
  Procedure,
  ProcedureDetail,
  ProcValidation,
} from "../../../../application/domain/proc-management";
import {
  ProcedureAcceptAppByMailInput,
  ProcedureApplicantsListInput,
  ProcedureDocumentsListInput,
  ProcedureSubmissionsListInput,
  ProcedureByMailInfoDestinationsListInput,
  ProcedureByMailInfoProxyApplyConditionInput,
  ProcedureByMailInfoFeeInput,
} from "../../../molecules/proc-management/form";

type Props = {
  procedure: ProcedureDetail | Procedure;
  onChange: (path: (string | number)[], value: any) => void;
  onFileAttached: (
    path: (string | number)[],
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  getFileUploading: (path: (string | number)[]) => boolean;
  isServiceProviderAccount?: boolean;
  minimizeForInputInSteps?: boolean;
  disabled?: boolean;
  shouldDisplayError?: boolean;
  validationErrors: ProcValidation;
};

export const ByMailInfoSection: React.FC<Props> = ({
  procedure,
  onChange,
  onFileAttached,
  getFileUploading,
  minimizeForInputInSteps = false,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
}) => {
  const { acceptAppByMail, byMailInfo } = procedure;
  const applicants = byMailInfo?.applicants ?? [];
  const documents = byMailInfo?.documents ?? [];
  const submissions = byMailInfo?.submissions ?? [];
  const destinations = byMailInfo?.destinations ?? [];

  return (
    <section className="mb-5">
      <h2 className="subtitle">郵送申請についての説明</h2>

      {!minimizeForInputInSteps && (
        <ProcedureAcceptAppByMailInput
          value={acceptAppByMail}
          basePath={["acceptAppByMail"]}
          onChange={onChange}
          disabled={disabled}
        />
      )}

      {acceptAppByMail && (
        <>
          <ProcedureApplicantsListInput
            value={applicants}
            onChange={onChange}
            basePath={["byMailInfo", "applicants"]}
            disabled={disabled}
            shouldDisplayError={shouldDisplayError}
            validationErrors={validationErrors.byMailInfo?.applicants ?? []}
          />

          <ProcedureDocumentsListInput
            label="郵送申請用様式"
            value={documents}
            basePath={["byMailInfo", "documents"]}
            onChange={onChange}
            onFileAttached={onFileAttached}
            getFileUploading={getFileUploading}
            disabled={disabled}
            shouldDisplayError={shouldDisplayError}
            validationErrors={validationErrors.byMailInfo?.documents ?? []}
          />

          <ProcedureSubmissionsListInput
            label="郵送申請添付物"
            value={submissions}
            basePath={["byMailInfo", "submissions"]}
            onChange={onChange}
            disabled={disabled}
            shouldDisplayError={shouldDisplayError}
            validationErrors={validationErrors.byMailInfo?.submissions ?? []}
          />

          <ProcedureByMailInfoDestinationsListInput
            value={destinations}
            onChange={onChange}
            disabled={disabled}
            basePath={["byMailInfo", "destinations"]}
            shouldDisplayError={shouldDisplayError}
            validationErrors={validationErrors.byMailInfo?.destinations ?? []}
          />

          {!minimizeForInputInSteps && (
            <ProcedureByMailInfoProxyApplyConditionInput
              value={byMailInfo?.acceptAppByProxyIf}
              onChange={onChange}
              basePath={["byMailInfo", "acceptAppByProxyIf"]}
              disabled={disabled}
              shouldDisplayError={shouldDisplayError}
              errorMsg={validationErrors.byMailInfo?.acceptAppByProxyIf}
            />
          )}

          <ProcedureByMailInfoFeeInput
            value={byMailInfo?.fee}
            onChange={onChange}
            basePath={["byMailInfo", "fee"]}
            disabled={disabled}
            shouldDisplayError={shouldDisplayError}
            errorMsg={validationErrors.byMailInfo?.fee}
          />
        </>
      )}
    </section>
  );
};
